import { PropsWithChildren } from 'react'

export default function Tabs(props: PropsWithChildren) {
  return (
    <ul className='font-medium flex flex-col space-y-1 md:space-y-0 p-4 md:p-0 mt-4 rounded-lg bg-gray-50 dark:bg-stone-900 md:flex-row md:space-x-8 md:mt-0 md:border-0 md:bg-transparent'>
      {props.children}
    </ul>
  )
}
